import BookIcon from "../../assets/book-solid.svg";

function PaperCard({ name }) {
    return <div className={"flex flex-col items-center max-w-[12em] mb-6 hover:underline cursor-pointer "}>
        <img src={BookIcon} className={"w-12 bg"}/>
        <p className={"text-sm mt-2"}>{name}</p>
    </div>;
}

export default PaperCard;